const title = {
  type: 'Paragraph',
  name: '1',
  fontSize: '32px',
  lineHeight: '40px',
  fontWeight: '300'
}

const blockTitle = {
  type: 'Label',
  name: '3'
}

const blockText = {
  type: 'Paragraph',
  name: '3',
  fontFamily: 'ChronicleTextG1-Roman, Chronicle Display'
}

const loyaltyRewardsCarousel = {
  title,
  blockTitle,
  blockText
}

export default loyaltyRewardsCarousel
